module.exports = __webpack_public_path__ + "img/banner_sample2.df04fc29.jpg";